export default __webpack_public_path__ + "static/media/gallery_36.de81dbed.jpg";